import React from 'react';
import PropTypes from 'prop-types';
import { List, Subheader, Divider, Paper } from 'material-ui';
import Error from '../../common/Error/Error';
import style from '../../../styles/styles';
import AchievementItem from '../AchievementItem/AchievementItem';

const AchievementList = (props) => {
    const { achievements, title, user, app } = props;

    let content;

    if (achievements.length === 0) {
        content =
            <Error
                title="No data"
                subtitle="Add some achievements"
            />;
    } else {
        content = achievements
            .sort((a, b) => {return a.name - b.name;})
            .map(function (achievement, index) {
            return <div key={achievement.id}>
                <AchievementItem
                    app={app}
                    user={user}
                    achievement={achievement}
                />
                {index !== (achievements.length - 1) && <Divider inset={true} />}
            </div>;
        });
    }

    return (
        <Paper>
            <List>
                <Subheader style={style.subHeader}>{title}</Subheader>
                {content}
            </List>
        </Paper>
    );
};

AchievementList.propTypes = {
    achievements: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    title: PropTypes.string,
    currentLang: PropTypes.string,
};

export default AchievementList;



// WEBPACK FOOTER //
// src/components/achievement/AchievementList/AchievementList.js